import {store} from '@/store';
import {userAtom} from '@/store/user';
import {buildMbApiUrl, fetchWithTimeout} from '@/util/request-utils';
import {type ExportPayload, type JobResponse} from '@/types/product-media';
import {MODELBANK_META} from './constants';

export async function createExport(
    params: ExportPayload
): Promise<JobResponse | null> {
    const user = store.get(userAtom);
    if (!user?.auth_token) {
        throw new Error('User not authenticated');
    }

    const meta = MODELBANK_META.get(params.type);
    if (!meta?.endpoints.create) {
        throw new Error(`Unknown export type: ${params.type}`);
    }

    const url = buildMbApiUrl(`/${meta.endpoints.create}`, {
        auth_token: user.auth_token,
    });

    const response = await fetchWithTimeout(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            job: {
                media_kind: meta.mediaKind,
                asset_type: 'Product',
                asset_id: params.id,
                settings: params.settings,
            },
        }),
    });

    if (!response.ok) {
        throw new Error(`Failed to create export: ${response.status}`);
    }

    return response.json();
}
